/**
 * Woodtastic sticky offset (V20.18)
 *
 * The announcement bar is sticky at the top, and the sticky header must sit
 * directly below it. The announcement bar's height is variable — on mobile the
 * shipping text wraps to 2–3 lines — so a hardcoded offset makes the header
 * overlap the bar on scroll. This measures the bar's REAL height and exposes it
 * as `--wt-announcement-height`, which the header's sticky `top` reads in CSS.
 */
(function () {
  'use strict';

  function getBar() {
    return (
      document.getElementById('shopify-section-announcement-bar') ||
      document.querySelector('.shopify-section-group-header-group:not(.section-header)')
    );
  }

  function setOffset() {
    var bar = getBar();
    var h = bar ? Math.round(bar.getBoundingClientRect().height) : 0;
    document.documentElement.style.setProperty('--wt-announcement-height', h + 'px');
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      setOffset();
    });
  }

  if (document.readyState !== 'loading') {
    setOffset();
  } else {
    document.addEventListener('DOMContentLoaded', setOffset);
  }
  window.addEventListener('load', setOffset);
  window.addEventListener('resize', schedule);
  window.addEventListener('orientationchange', schedule);

  // Recompute if the bar itself reflows (text change, font load, etc.)
  var bar = getBar();
  if (window.ResizeObserver && bar) {
    new ResizeObserver(schedule).observe(bar);
  }
})();
